<template>
  <div class="audio-hero-content">
    <h1
      :class="{
        'audio-hero-content__headline': true,
        'audio-hero-content__headline--h2-mobile': isEnglishLang
      }"
      v-html="formattedHeadline" />

    <div
      class="audio-hero-content__subheadline"
      v-html="$t('subheadline')" />

    <start-trial-button
      class="audio-hero-content__cta"
      event-category="body-20210610-audio_hero"
      :modifiers="['x-wide']" />
  </div>
</template>

<script>
import globals from "@/utils/globals";
import StartTrialButton from "@/shared/start-trial-button";

export default {
  components: {
    StartTrialButton
  },
  name: "AudioHeroContent",
  props: {
    headlineVariation: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedHeadline () {
      return this.$t(this.headlineVariation, {
        totalBooks: globals.totalBooks
      });
    },
    isEnglishLang() {
      return this.$i18n.locale === "en";
    }
  },
  i18n: {
    messages: {
      en: {
        headlineB: "More knowledge <br class='hidden-mobile'>in less time",
        subheadline: "Perfect for curious people who love to learn, busy people who don’t have time to read, and even people who aren’t into reading."
      },
      de: {
        headlineB: "Hol dir das Beste aus <br  class='hidden-mobile'>über {totalBooks} Sachbüchern <br  class='hidden-mobile'>in 15 Minuten pro Titel",
        subheadline: "Für alle, die die Welt verstehen, mehr wissen und mehr können wollen – in weniger Zeit. "
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.audio-hero-content {

  @include container();

  z-index: 1;

  display: grid;

  margin-bottom: $spacing-16;

  &__subheadline {
    @include font-style((xs:p1, m:p0 ));
    @include grid-css-element(12);

    margin-bottom: $spacing-24;

    color: $deep-black;
    @include media(min-width, m) {
      margin-bottom: $spacing-32;
      grid-area: 2 / 1 / 2 / 12;
    }
    @include media(min-width, l) {
      margin-bottom: $spacing-32;
      grid-area: 2 / 1 / 2 / 8;
    }
  }

  &__cta {
    @include grid-css-element(12);

    @include media(min-width,m) {
      grid-area: 3 / 1 / 3 / 5;
    }
  }

  &__headline {
    @include font-style((xs: h3, m: h2, l: h1));
    @include grid-css-element(12);

    margin-top: $spacing-24;
    margin-bottom: $spacing-16;

    &--h2-mobile {
      @include font-style((xs: h2, m: h2, l: h1));
    }

    @include media(min-width, m) {
      margin-bottom: $spacing-24;
      grid-area: 1 / 1 / 1 / 13;
    }

    @include media(min-width, l) {
      margin-top: $spacing-64;

      font-size: 2.5rem;
    }
  }
}

::v-deep .hidden-mobile { /* stylelint-disable-line */
  display: none;
  @include media(min-width, l) {
    display: block;
  }
}
</style>
